import React from "react"

const Contact = () => (
  <p>
    <span className="field">
      <a href="mailto:koistinenemmisofia@gmail.com" rel="noopener noreferrer">
        Email
      </a>
    </span>
    <br />
    <span className="field">
      <a
        href="https://www.linkedin.com/in/emmi-koistinen-a21730133/"
        rel="noopener noreferrer"
        target="_blank"
      >
        LinkedIn
      </a>
    </span>
  </p>
)

export default Contact
